import { noop } from '../../../../../lib/utilities';
import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../structure/row';
import { Cell, CENTER } from '../structure/cell';
import { Translation } from '../../translation/translation';

function AddToCartNote(props) {
    if (props.hasFitting) {
        return null;
    }

    const translationKey = props.fittingNotAvailable ?
        'pdp-sidebar-add-to-cart-add-to-calculate-shipping' :
        'pdp-sidebar-add-to-cart-add-for-home-delivery';

    return (
        <Translation
            translationKey={translationKey}
            className="add-to-cart__note"
            tagName="div"
        />
    );
}

AddToCartNote.propTypes = {
    fittingNotAvailable: PropTypes.bool.isRequired,
    hasFitting: PropTypes.bool.isRequired,
};


export const AddToCart = (props) => (
    <Row className="add-to-cart sidebar__row-container--has-fitting">
        <Cell side={CENTER} colSpan={3} className="add-to-cart__cell">
            <Translation
                tagName="button"
                className="add-to-cart__button"
                onClick={(e) => { props.onAddClick(e, props) }}
                translationKey="pdp-sidebar-add-to-cart-button"
            />
            <AddToCartNote
                fittingNotAvailable={props.fittingNotAvailable}
                hasFitting={props.hasFitting}
            />
        </Cell>
    </Row>
);

AddToCart.propTypes = {
    fittingNotAvailable: PropTypes.bool.isRequired,
    baseUrl: PropTypes.string.isRequired,
    hasFitting: PropTypes.bool.isRequired,
    onAddClick: PropTypes.func,
    productQuantity: PropTypes.number.isRequired,
    tyreId: PropTypes.string.isRequired,
    fittingStationId: PropTypes.string.isRequired,
    wheelAlignmentTwo: PropTypes.bool.isRequired,
    wheelAlignmentFour: PropTypes.bool.isRequired,
};

AddToCart.defaultProps = {
    onAddClick: noop,
};
